module.exports = __webpack_public_path__ + "static/img/xt_pass.2ee4282.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xt_pass.png
// module id = M9fH
// module chunks = 1